import { Plus } from "lucide-react";
import { Link } from "wouter";

type MobileAccountActionProps = { href: string; label: string };

/** Account lists share one mobile action style; the caller owns its destination. */
export function MobileAccountAction({ href, label }: MobileAccountActionProps) {
  return (
    <Link href={href} aria-label={label} title={label}
      className="mobile-account-post fixed bottom-[max(1.25rem,env(safe-area-inset-bottom))] right-5 z-40 inline-flex h-14 w-14 items-center justify-center rounded-full bg-navy text-white shadow-lg transition hover:bg-navy-600 active:scale-95 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-gold sm:hidden">
      <Plus className="h-7 w-7" strokeWidth={2.5} aria-hidden="true" />
    </Link>
  );
}
